document.addEventListener('DOMContentLoaded', () => {
    console.log("JS Loaded");
    const browse = document.getElementById('browsePhotos');
    const addMore = document.getElementById('addMorePhotos');
    const input = document.getElementById('photoUpload');

    const grid = document.getElementById('photoGrid');
    const counter = document.getElementById('uploadCounter');
    const uploadBox = document.getElementById('uploadBox');
    const price = document.getElementById('otmProductPrice');

    const packs = [...document.querySelectorAll('.otm-pack')];
    const qtyValue =
        document.getElementById("qtyValue");

    const qtyMinus =
        document.getElementById("qtyMinus");

    const qtyPlus =
        document.getElementById("qtyPlus");
    const continueBtn = document.getElementById("continueButton");

    const APP_VERSION = "2.0.0";

    //AWS
    const API_URL =
"https://ucfnscsco1.execute-api.ap-south-1.amazonaws.com/prod/upload";

    const productTitle = document.querySelector(".otm-product__title")?.textContent.trim() || "Photo Magnet";

    const appState = {

        get pack() {
            return selectedPack;
        },

        get quantity() {
            return selectedQuantity;
        },

        get capacity() {
            return getCapacity();
        },

        get totalMagnets() {
            return getTotalMagnets();
        },

        get variantId() {
            return selectedVariantId;
        }

    };

    let uploadedPhotos = [];
    
    let selectedPack = Number(
        document.querySelector(".otm-pack.active")?.dataset.pack || 3
    );

    let selectedQuantity = 1;

    // ---- Frame mode: fixed photo count, no packs, no copies ----
    // Driven by a hidden #frameCount input set from product tags (frame-1/4/6)
    const frameCountEl = document.getElementById("frameCount");
    const FRAME_COUNT = frameCountEl ? (parseInt(frameCountEl.value, 10) || 0) : 0;
    // Products without pack pills (keychains, frames): default variant fallback
    setTimeout(() => {
        const dv = document.getElementById("defaultVariant");
        if (dv && dv.value && selectedVariantId === null) {
            selectedVariantId = dv.value;
        }
    }, 0);

    // Bridge for otm-variant-picker.liquid: it can't reach this closure's
    // selectedVariantId directly, so it calls this setter instead.
    window.otmSetVariant = function(id, price) {
        selectedVariantId = id;
        // Keychains own their price display via updateKcTotal(); don't let
        // the single-variant picker overwrite it once that's active.
        if (document.getElementById("otmColorLegend")) return;
        const priceEl = document.getElementById("otmProductPrice");
        if (priceEl && price != null) {
            priceEl.textContent = "$" + (price / 100).toFixed(2);
        }
    };

    // Keep the price live as "Number of Packs" changes, without needing to
    // know that stepper's own element id: watch the existing photo counter,
    // since its capacity number IS the pack count for fixed-pack products.
    (function watchPackCountForPrice(){
        const counterEl = document.getElementById("uploadCounter");
        if (!counterEl || !document.getElementById("otmColorLegend")) return;
        const obs = new MutationObserver(() => updateKcTotal());
        obs.observe(counterEl, { childList: true, characterData: true, subtree: true });
        updateKcTotal();
    })();

    // NaN armor: products without pack pills must never poison the math
    if (!Number.isFinite(selectedPack) || selectedPack < 1) selectedPack = 1;
    if (!Number.isFinite(selectedQuantity) || selectedQuantity < 1) selectedQuantity = 1;

    // ---- Fixed-pack mode: pack locked to 1, quantity stepper = item count ----
    const fixedPackEl = document.getElementById("fixedPack");
    const FIXED_PACK = fixedPackEl ? (parseInt(fixedPackEl.value, 10) || 0) : 0;
    if (FIXED_PACK > 0) {
        selectedPack = FIXED_PACK;
        document.body.classList.add("otm-fixed-pack");
    }
    // Paint counter on load for fixed-pack too
    setTimeout(function(){ try { updateCounter(); } catch(e){} }, 0);

    if (FRAME_COUNT > 0) {
        selectedPack = FRAME_COUNT;
        selectedQuantity = 1;
        document.body.classList.add("otm-frame-mode");
        // Paint the counter immediately so it never shows the stale placeholder
        setTimeout(function(){ try { updateCounter(); } catch(e){} }, 0);

        const fmFont = document.getElementById("frameMessageFont");
        const fmText = document.getElementById("frameMessage");
        if (fmFont && fmText) {
            const applyFont = () => {
                fmText.style.fontFamily = '"' + fmFont.value + '", sans-serif';
            };
            fmFont.addEventListener("change", applyFont);
            applyFont();
        }
        const fmCount = document.getElementById("frameMsgCount");
        if (fmText && fmCount) {
            const max = fmText.maxLength > 0 ? fmText.maxLength : 30;
            const updateCount = () => {
                fmCount.textContent = fmText.value.length + " / " + max;
                fmCount.classList.toggle("full", fmText.value.length >= max);
            };
            fmText.addEventListener("input", updateCount);
            updateCount();
        }
        const fmEmojis = document.getElementById("frameEmojiRow");
        if (fmText && fmEmojis) {
            fmEmojis.addEventListener("click", (e) => {
                const btn = e.target.closest("button[data-emoji]");
                if (!btn) return;
                const emoji = btn.dataset.emoji;
                const max = fmText.maxLength > 0 ? fmText.maxLength : 45;
                if (fmText.value.length + emoji.length > max) return;
                fmText.value += emoji;
                fmText.dispatchEvent(new Event("input"));
                fmText.focus();
            });
        }
    }

    function getOrderSummary() {

        return {

            product: productTitle,

            variantId: appState.variantId,

            pack: appState.pack,

            quantity: appState.quantity,

            capacity: appState.capacity,

            totalMagnets: appState.totalMagnets,

            totalPhotos: uploadedPhotos.length

        };

    }

    function getCapacity() {

        if (FRAME_COUNT > 0) return FRAME_COUNT;

        return selectedPack * selectedQuantity;

    }

    function getTotalMagnets() {

        return uploadedPhotos.reduce(

            (sum, photo) => sum + photo.copies,

            0

        );

    }

    function getAvailablePacks() {

        return packs
            .map(pack => Number(pack.dataset.pack))
            .sort((a, b) => a - b);

    }

    function getLargestPack() {

        return Math.max(...getAvailablePacks());

    }

    function getNextPack(currentPack) {

        return getAvailablePacks().find(

            pack => pack > currentPack

        );

    }

    function updatePrice() {

        const activePack = packs.find(
            p => Number(p.dataset.pack) === selectedPack
        );

        if (activePack) {

            price.textContent = activePack.dataset.price;

        }

    }

    function updateContinueButton() {

        continueBtn.disabled =
            getTotalMagnets() !== getCapacity();

    }

    // function updateReviewSummary() {

    //     const order = getOrderSummary();
        
    //     const packName =
    //         document.getElementById("reviewPackName");

    //     const magnetCount =
    //         document.getElementById("reviewMagnetCount");

    //     const reviewPrice =
    //         document.getElementById("reviewTotalPrice");

    //     if (!packName) return;

    //     packName.textContent =
    //         `${order.pack} Magnet Pack × ${order.quantity}`;

    //     magnetCount.textContent =
    //         `${order.totalMagnets} / ${order.capacity}`;

    //     reviewPrice.textContent =
    //         price.textContent;

    // }

    function updateReviewSummary() {

        const order = getOrderSummary();

        console.log("===== Review Summary =====");
        console.log("uploadedPhotos", uploadedPhotos);
        console.log("totalMagnets =", order.totalMagnets);
        console.log("capacity =", order.capacity);
        console.log("uploadedPhotos =", uploadedPhotos.map(p => p.copies));

        const packName =
            document.getElementById("reviewPackName");

        const magnetCount =
            document.getElementById("reviewMagnetCount");

        const reviewPrice =
            document.getElementById("reviewTotalPrice");

        if (!packName) return;

        packName.textContent =
            `${order.pack} Magnet Pack × ${order.quantity}`;

        magnetCount.textContent =
            `${order.totalMagnets} / ${order.capacity}`;

        reviewPrice.textContent =
            price.textContent;

}

    function refreshUI() {

        updateCounter();

        updatePrice();

        updateContinueButton();

        updateReviewSummary();

    }
    
    let selectedVariantId = null;

    //crop functionality variable
    let cropper = null;

    let currentCropIndex = 0;

    //review
    let cropSource = "product";

    const cropModal =
        document.getElementById("cropModal");

    const cropImage =
        document.getElementById("cropImage");

    const cropTitle =
        document.getElementById("cropTitle");

    const cropNext =
        document.getElementById("cropNext");

    const cropBack =
        document.getElementById("cropBack");

    const cropClose =
        document.getElementById("closeCropper");

    // ---- Magnet type & crop specifications ----
    // Aspect ratio and output resolution per magnet type.
    // The type comes from the hidden #magnetType input (set by Liquid from product tags).
    const TYPE_SPECS = {
        "2x2":           { ratio: 1,       outW: 800,  outH: 800,  shape: "square" },
        "rect-2.5x3.5":  { ratio: 2.7/3.7, outW: 800,  outH: 1096, shape: "square" },
        "round-1.3in":   { ratio: 1,       outW: 600,  outH: 600,  shape: "circle" },
        "round-2in":     { ratio: 1,       outW: 800,  outH: 800,  shape: "circle" },
        "round-58mm":    { ratio: 1,       outW: 800,  outH: 800,  shape: "circle" },
        "round-5in":     { ratio: 1,       outW: 1600, outH: 1600, shape: "circle" }
    };

    // Grid thumbnails should reflect each type's real proportions —
    // square stays square, rectangle shows its true portrait shape,
    // rounds get circle-masked. Set once at page load (not just when the
    // crop modal opens) so this is correct even before a photo is cropped.
    // (Placed here, after TYPE_SPECS, so magnetSpec() has what it needs.)
    document.body.style.setProperty("--otm-thumb-ratio", magnetSpec().ratio);
    document.body.classList.toggle("otm-round-crop", magnetSpec().shape === "circle");
    function magnetSpec() {
        const el = document.getElementById("magnetType");
        const type = el ? el.value : "2x2";
        return TYPE_SPECS[type] || TYPE_SPECS["2x2"];
    }

    //AWS S3 upload function
    // 1.3in mini keychains: each physical unit needs TWO printed circles
    // (front + back of the band). This is invisible to the customer —
    // they upload N photos for N keychains; we silently request and
    // upload 2N files to S3 so fulfillment has both copies ready.
    function otmNeedsDoublePrint(){
        const magnetTypeEl = document.getElementById("magnetType");
        return magnetTypeEl && magnetTypeEl.value === "round-1.3in";
    }

    async function requestUploadUrls() {

        // Magnet type comes from a hidden input set by Liquid (e.g. 2x2, round, rectangle)
        const magnetTypeEl = document.getElementById("magnetType");
        const magnetType = magnetTypeEl ? magnetTypeEl.value : "2x2";

        const doubleUp = otmNeedsDoublePrint();
        let photoRequests = uploadedPhotos.map(photo => ({ copies: photo.copies }));
        if (doubleUp) {
            // Ask for one URL per photo, then one more per photo (interleaved
            // pairs), so uploadAllImages can send each photo to both.
            const doubled = [];
            photoRequests.forEach(p => { doubled.push(p); doubled.push(p); });
            photoRequests = doubled;
        }

        const response = await fetch(API_URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                magnetType: magnetType,
                photos: photoRequests
            })
        });
        if (!response.ok) {
            throw new Error("Unable to request upload URLs");
        }
        // return await response.json();
        const data = await response.json();
        console.log(data);
        return data;
    }

    async function uploadAllImages(uploadResponse) {

        const uploads = uploadResponse.uploads;
        const total = uploadedPhotos.length;
        const doubleUp = otmNeedsDoublePrint();

        for (let i = 0; i < total; i++) {
            const percent = 25 + Math.round(((i) / total) * 55);
            setUploadProgress(
                percent,
                1,
                `Uploading Photo ${i + 1} of ${total}`
            );

            // Which upload-URL slot(s) correspond to this photo. Normally
            // one slot per photo (index i). When doubling, requestUploadUrls
            // asked for two consecutive slots per photo, so photo i uses
            // slots 2i and 2i+1 — both get the SAME file, invisibly.
            const slots = doubleUp ? [i * 2, i * 2 + 1] : [i];

            for (const slot of slots) {
                const response = await fetch(
                    uploads[slot].uploadUrl,
                    {
                        method: "PUT",
                        headers: {
                            "Content-Type": "image/jpeg"
                        },
                        body: uploadedPhotos[i].croppedBlob
                    }
                );
                if (!response.ok) {
                    throw new Error(
                        `Failed to upload ${uploads[slot].filename}`
                    );
                }
            }
        }
    }

    // function buildManifest(uploadResponse) {

    //     return {
    //         version: 1,
    //         folder: uploadResponse.folder,
    //         createdAt: new Date().toISOString(),
    //         pack: selectedPack,
    //         quantity: selectedQuantity,
    //         capacity: getCapacity(),
    //         totalMagnets: uploadedPhotos.reduce(
    //             (sum, photo) => sum + photo.copies,
    //             0
    //         ),
    //         product: productTitle,
    //         photos: uploadedPhotos.map((photo, index) => ({
    //             file: uploadResponse.uploads[index].filename,
    //             copies: photo.copies,
    //             crop: photo.crop,
    //             rotation: photo.rotation,
    //             originalName: photo.file.name
    //         }))
    //     };

    // }

    function buildManifest(uploadResponse) {

        const order = getOrderSummary();

        const socialCb = document.getElementById("socialConsent");

        return {

             version: APP_VERSION,

            folder: uploadResponse.folder,

            createdAt: new Date().toISOString(),

            socialOk: !!(socialCb && socialCb.checked),

            category: document.getElementById("productCategory")?.value || "magnet",

            frame: FRAME_COUNT > 0 ? {
                count: FRAME_COUNT,
                message: (document.getElementById("frameMessage")?.value || "").trim(),
                messageFont: document.getElementById("frameMessageFont")?.value || "Poppins"
            } : undefined,

            ...order,

            photos: uploadedPhotos.map((photo, index) => ({

                file: uploadResponse.uploads[index].filename,

                originalName: photo.file.name,

                copies: photo.copies,

                crop: photo.crop,

                rotation: photo.rotation

            }))

        };

    }

    async function uploadManifest(uploadResponse) {

        const manifest = buildManifest(uploadResponse);
        console.log("Manifest Upload URL:");
        console.log(uploadResponse.manifestUploadUrl);
        const response = await fetch(
            uploadResponse.manifestUploadUrl,
            {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(manifest)
            }
        );
        if (!response.ok) {
            throw new Error("Failed to upload manifest.json");
        }
    }

    //Checkout functionality starts

    // async function createShopifyCart(uploadResponse) {

    //     const variantId = selectedVariantId;      
    //     console.log("Variant ID:", variantId);
    //     console.log("Product Title:", productTitle);
    //     throw new Error(errorText);
    //     const addResponse = await fetch("/cart/add.js", {
    //         method: "POST",
    //         headers: {
    //             "Content-Type": "application/json"
    //         },
    //         body: JSON.stringify({
    //             items: [{
    //                 id: Number(selectedVariantId),
    //                 quantity: 1
    //             }]
    //         })
    //     });

    //     const addText = await addResponse.text();

    //     console.log("Status:", addResponse.status);
    //     console.log("Body:", addText);

    //     if (!addResponse.ok) {
    //         throw new Error(addText);
    //     }
    //     console.log("Variant ID =", variantId);
    //     console.log("Quantity =", 1);
    //     throw new Error(errorText);
    //     const updateResponse = await fetch("/cart/update.js", {

    //         method: "POST",
    //         headers: {
    //             "Content-Type": "application/json"
    //         },
    //         body: JSON.stringify({
    //             attributes: {
    //                 otmFolder: uploadResponse.folder,
    //                 // otmPack: selectedPack,
    //                 otmPack:selectedPack,

    //                 otmQuantity:selectedQuantity,

    //                 otmCapacity:getCapacity(),
    //                 otmMagnets: uploadedPhotos.reduce(
    //                     (sum, p) => sum + p.copies,
    //                     0
    //                 ),
    //                 otmVersion: 1
    //             }
    //         })
    //     });
    //     if (!updateResponse.ok) {
    //         throw new Error("Unable to save cart attributes.");
    //     }
    // }


    async function createShopifyCart(uploadResponse) {
        console.log("===== createShopifyCart() =====");
        console.log("selectedVariantId =", selectedVariantId);
        console.log("selectedPack =", selectedPack);

        // const variantId =
            // document.getElementById("variantSelector").value;
        const variantId = selectedVariantId;
        // Add product

        // Per-photo keychains: each uploaded photo now carries its own
        // bandColor/engrave choice (set in renderPhotos()). If present,
        // send one cart line per photo instead of a single line at pack
        // quantity. Falls back to the original single-line behavior for
        // every other product (bandColor stays undefined there).
        const kcVariantsEl = document.getElementById("otmVariantsJson");
        let cartItems = [{ id: Number(variantId), quantity: selectedQuantity }];

        if (kcVariantsEl && uploadedPhotos.length > 0 && uploadedPhotos[0].bandColor !== undefined) {
            try {
                const allVariants = JSON.parse(kcVariantsEl.textContent);
                cartItems = uploadedPhotos.map((photo) => {
                    const v = allVariants.find(av =>
                        av.option1 === photo.bandColor &&
                        (photo.engrave ? /engraved/i.test(av.option2 || "") : !/engraved/i.test(av.option2 || ""))
                    );
                    const item = { id: Number(v ? v.id : variantId), quantity: photo.copies || 1 };
                    if (photo.engrave && photo.engraveText) {
                        item.properties = {
                            "Engraving": photo.engraveText,
                            "Font": photo.engraveFont,
                            "Size": String(photo.engraveSize),
                            "Photo": photo.originalPreview ? "linked" : ""
                        };
                    }
                    return item;
                });
            } catch (e) {
                console.warn("Per-photo keychain parse failed, falling back to single line:", e);
            }
        }

        const addResponse = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ items: cartItems })
        });

        if (!addResponse.ok) {
            throw new Error("Unable to add product to cart.");
        }

        // Save metadata

        const order = getOrderSummary();

        const updateResponse = await fetch("/cart/update.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                attributes: {
                    otmFolder: uploadResponse.folder,
                    otmCategory: document.getElementById("productCategory")?.value || "magnet",
                    otmFrameMessage: FRAME_COUNT > 0
                        ? (document.getElementById("frameMessage")?.value || "").trim()
                        : undefined,
                    otmFrameFont: FRAME_COUNT > 0
                        ? (document.getElementById("frameMessageFont")?.value || "Poppins")
                        : undefined,
                    otmEngraving: (document.getElementById("otmEngravingBox")?.style.display !== "none")
                        ? (document.getElementById("engravingText")?.value || "").trim()
                        : undefined,
                    otmEngravingFont: (document.getElementById("otmEngravingBox")?.style.display !== "none")
                        ? (document.getElementById("engravingFont")?.value || "Poppins")
                        : undefined,
                    otmEngravingSize: (document.getElementById("otmEngravingBox")?.style.display !== "none")
                        ? (document.getElementById("engravingSize")?.value || "18")
                        : undefined,
                    otmPack: order.pack,
                    otmQuantity: order.quantity,
                    otmCapacity: order.capacity,
                    otmMagnets: order.totalMagnets,
                    otmProduct: order.product,
                    otmVersion: APP_VERSION
                }
            })
        });

        if (!updateResponse.ok) {
            throw new Error("Unable to save cart attributes.");
        }
    }
    //Checkout functionality ends


    // upload overlay screen
    const uploadSteps = [
        "stepReserve",
        "stepUpload",
        "stepManifest",
        "stepCheckout"
    ];

    function showUploadOverlay() {

        document
            .getElementById("uploadOverlay")
            .classList.add("active");

    }

    function hideUploadOverlay() {

        document
            .getElementById("uploadOverlay")
            .classList.remove("active");

    }

    function setUploadProgress(percent, activeIndex, message) {

        document.getElementById("uploadProgressBar").style.width = percent + "%";
        document.getElementById("uploadPercent").textContent = percent + "%";
        uploadSteps.forEach((id, index) => {
            const el = document.getElementById(id);
            const label = el.dataset.label;
            if (index < activeIndex) {
                el.innerHTML = "✅ " + label;
                el.className = "upload-step done";
            }
            else if (index === activeIndex) {
                el.innerHTML =
                    `<span class="spinner"></span>${message}`;
                el.className = "upload-step active";
            }
            else {
                el.innerHTML = "○ " + label;
                el.className = "upload-step";
            }
        });
    }

// upload overlay screen ends
        

    const firstPack = document.querySelector(".otm-pack.active");

        if (firstPack) {

            selectedVariantId = Number(firstPack.dataset.variantId);

        }

    // browse.addEventListener('click', () => input.click());
    browse.addEventListener('click', () => {
        console.log("Browse clicked");
        // throw new Error(errorText);
        input.click();
    });

addMore.addEventListener('click', () => input.click());

// Manual pack selection
packs.forEach(pack => {
    pack.addEventListener("click", () => {
        if (FRAME_COUNT > 0 || FIXED_PACK > 0) return;
        selectedPack = Number(pack.dataset.pack);
        selectedVariantId = Number(pack.dataset.variantId);
        highlightPack(selectedPack);
        updateCounter();
    });
});

// ---- iPhone HEIC support: convert to JPEG in the browser ----
let heicLibPromise = null;
function ensureHeicLib() {
    if (!heicLibPromise) {
        heicLibPromise = new Promise((resolve, reject) => {
            const s = document.createElement("script");
            s.src = "https://cdnjs.cloudflare.com/ajax/libs/heic2any/0.0.4/heic2any.min.js";
            s.onload = resolve;
            s.onerror = () => reject(new Error("Could not load photo converter"));
            document.head.appendChild(s);
        });
    }
    return heicLibPromise;
}

function isHeicFile(file) {
    const name = (file.name || "").toLowerCase();
    return file.type === "image/heic" || file.type === "image/heif" ||
        name.endsWith(".heic") || name.endsWith(".heif");
}

async function normalizeFile(file) {
    if (!isHeicFile(file)) return file;
    await ensureHeicLib();
    const converted = await heic2any({
        blob: file,
        toType: "image/jpeg",
        quality: 0.92
    });
    const blob = Array.isArray(converted) ? converted[0] : converted;
    return new File(
        [blob],
        (file.name || "photo").replace(/\.[^.]+$/, "") + ".jpg",
        { type: "image/jpeg" }
    );
}

input.addEventListener("change", async function () {
    const rawFiles = [...this.files];
    this.value = "";
    if (!rawFiles.length) return;

    showPhotoLoading(rawFiles.length);

    for (const rawFile of rawFiles) {
        if (FIXED_PACK > 0 && uploadedPhotos.length >= getCapacity()) {
            alert("Increase the Number of Packs to add more photos.");
            break;
        }
        if (FRAME_COUNT > 0 && uploadedPhotos.length >= FRAME_COUNT) {
            alert("This frame holds exactly " + FRAME_COUNT + " photo" + (FRAME_COUNT > 1 ? "s" : "") + ".");
            break;
        }
        let file;
        try {
            file = await normalizeFile(rawFile);
        } catch (e) {
            alert("Sorry, we couldn't read \"" + (rawFile.name || "one of your photos") +
                "\". Please try a different photo.");
            continue;
        }
        uploadedPhotos.push({
            id: Date.now() + Math.random(),
            file: file,
            originalPreview: URL.createObjectURL(file),
            croppedPreview: null,
            copies: 1,
            crop: null,
            rotation: 0,
            text: "",
            textFont: "Poppins",
            textSize: 9,
            textPos: "bottom",
            textColor: "#ffffff",
            brightness: 100,
            contrast: 100,
            saturation: 100
        });
    }
    autoUpgradePack();
    renderPhotos();
    hidePhotoLoading();

    // Bring the uploaded photos (and Continue button) into view
    setTimeout(() => {
        grid.scrollIntoView({
            behavior: "smooth",
            block: "center"
        });
    }, 150);
});

function showPhotoLoading(count){
    let ov = document.getElementById("otmPhotoLoading");
    if (!ov) {
        ov = document.createElement("div");
        ov.id = "otmPhotoLoading";
        ov.className = "otm-photo-loading";
        ov.innerHTML =
            '<div class="otm-photo-loading__spinner"></div>' +
            '<span class="otm-photo-loading__text"></span>';
        grid.insertAdjacentElement("beforebegin", ov);
    }
    ov.querySelector(".otm-photo-loading__text").textContent =
        count > 1 ? ("Loading " + count + " photos…") : "Loading your photo…";
    ov.classList.add("show");
}

function hidePhotoLoading(){
    const ov = document.getElementById("otmPhotoLoading");
    if (ov) ov.classList.remove("show");
}

function showCropSaved(){
    const toast =
        document.getElementById("cropToast");
    toast.classList.add("show");
    setTimeout(()=>{
        toast.classList.remove("show");
    },1200);
}

function otmKeychainColors(){
    const el = document.getElementById("otmVariantsJson");
    if (!el) return [];
    try {
        const variants = JSON.parse(el.textContent);
        const seen = [];
        variants.forEach(v => {
            if (!seen.find(c => c.value === v.option1)) {
                seen.push({ value: v.option1, image: v.featured_media ? v.featured_media.preview_image.src : null });
            }
        });
        return seen;
    } catch (e) { return []; }
}

function otmKeychainHasEngraving(){
    const el = document.getElementById("otmVariantsJson");
    if (!el) return false;
    try {
        const variants = JSON.parse(el.textContent);
        return variants.some(v => /engraved/i.test(v.option2 || ""));
    } catch (e) { return false; }
}

function renderPhotos(){

    const kcColors = otmKeychainColors();
    const kcHasEngraving = otmKeychainHasEngraving();

    grid.innerHTML = "";
    uploadedPhotos.forEach(photo => {

        let kcBlock = "";
        if (kcColors.length > 0) {
            if (photo.bandColor === undefined) photo.bandColor = kcColors[0].value;
            if (photo.engrave === undefined) photo.engrave = false;
            if (photo.engraveText === undefined) photo.engraveText = "";
            if (photo.engraveFont === undefined) photo.engraveFont = "Poppins";
            if (photo.engraveSize === undefined) photo.engraveSize = 18;

            const swatches = kcColors.map((c, idx) => {
                const active = c.value === photo.bandColor ? " active" : "";
                return `<button type="button" class="otm-photo-numpill${active}" data-id="${photo.id}" data-color="${c.value}" title="${c.value}">${idx + 1}</button>`;
            }).join("");

            let engBlock = "";
            if (kcHasEngraving) {
                engBlock = `<label class="otm-kc-engtoggle">
                    <input type="checkbox" class="otm-photo-engcheck" data-id="${photo.id}" ${photo.engrave ? "checked" : ""}> Engrave this one
                  </label>
                  <p class="otm-kc-engboth">Engraving is applied to both sides of the band.</p>`;
                if (photo.engrave) {
                    const bandInfo = kcColors.find(c => c.value === photo.bandColor);
                    const bandBg = bandInfo && bandInfo.image
                        ? `background-image:url('${bandInfo.image}&width=340');background-size:cover;background-position:center;`
                        : `background:#4A3629;`;
                    engBlock += `<div class="otm-kc-engfields">
                        <input type="text" maxlength="10" class="otm-photo-engtext" data-id="${photo.id}" placeholder="e.g. J + M" value="${photo.engraveText.replace(/"/g,'&quot;')}">
                        <select class="otm-photo-engfont" data-id="${photo.id}">
                          ${["Poppins","Pacifico","Bebas Neue","Caveat","Playfair Display"].map(f =>
                            `<option value="${f}" ${photo.engraveFont===f?"selected":""}>${f}</option>`).join("")}
                        </select>
                        <input type="range" min="12" max="28" class="otm-photo-engsize" data-id="${photo.id}" value="${photo.engraveSize}">
                        <div class="otm-band" style="${bandBg}">
                          <div class="otm-band__zone">
                            <span class="otm-band__text" style="font-family:'${photo.engraveFont}',sans-serif;font-size:${photo.engraveSize}px">${photo.engraveText || "J + M"}</span>
                          </div>
                        </div>
                      </div>`;
                }
            }

            const selectedName = kcColors.find(c => c.value === photo.bandColor);
            kcBlock = `<div class="otm-photo-kc">
                <div class="otm-photo-kc__current">Band: <strong>${photo.bandColor}</strong></div>
                <div class="otm-numpillrow">${swatches}</div>
                ${engBlock}
              </div>`;
        }

        grid.innerHTML += `
        <div
            class="otm-photo-card"
            data-id="${photo.id}">

            <img
                src="${photo.originalPreview}"
                class="otm-photo-image">

            <div class="otm-photo-controls">
                <button
                    class="otm-minus"
                    data-id="${photo.id}">
                    −
                </button>
                <span>
                    ${photo.copies}
                </span>
                <button
                    class="otm-plus"
                    data-id="${photo.id}">
                    +
                </button>
            </div>
            <button
                class="otm-remove"
                data-id="${photo.id}"
                title="Remove Photo"
                aria-label="Remove Photo">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M18 6L6 18M6 6L18 18"
                        stroke="currentColor"
                        stroke-width="2.5"
                        stroke-linecap="round"/>
                </svg>
            </button>
            ${kcBlock}
        </div>
        `;
    });

    // Wire per-photo keychain controls (delegated once per render is fine here
    // since grid.innerHTML was just rebuilt)
    grid.querySelectorAll(".otm-photo-numpill").forEach(btn => {
        btn.addEventListener("click", () => {
            const p = uploadedPhotos.find(p => p.id == btn.dataset.id);
            if (p) { p.bandColor = btn.dataset.color; renderPhotos(); updateKcTotal(); }
        });
    });
    grid.querySelectorAll(".otm-photo-engcheck").forEach(cb => {
        cb.addEventListener("change", () => {
            const p = uploadedPhotos.find(p => p.id == cb.dataset.id);
            if (p) { p.engrave = cb.checked; renderPhotos(); updateKcTotal(); }
        });
    });
    grid.querySelectorAll(".otm-photo-engtext").forEach(inp => {
        inp.addEventListener("input", () => {
            const p = uploadedPhotos.find(p => p.id == inp.dataset.id);
            if (p) {
                p.engraveText = inp.value;
                const card = inp.closest(".otm-photo-kc");
                const span = card && card.querySelector(".otm-band__text");
                if (span) span.textContent = inp.value || "J + M";
            }
        });
    });
    grid.querySelectorAll(".otm-photo-engfont").forEach(sel => {
        sel.addEventListener("change", () => {
            const p = uploadedPhotos.find(p => p.id == sel.dataset.id);
            if (!p) return;
            p.engraveFont = sel.value;
            const card = sel.closest(".otm-photo-kc");
            const span = card && card.querySelector(".otm-band__text");
            if (span) span.style.fontFamily = "'" + p.engraveFont + "', sans-serif";
        });
    });
    grid.querySelectorAll(".otm-photo-engsize").forEach(rng => {
        rng.addEventListener("input", () => {
            const p = uploadedPhotos.find(p => p.id == rng.dataset.id);
            if (!p) return;
            p.engraveSize = +rng.value;
            const card = rng.closest(".otm-photo-kc");
            const span = card && card.querySelector(".otm-band__text");
            if (span) span.style.fontSize = p.engraveSize + "px";
        });
    });

    let sharedDisclaimer = document.getElementById("otmEngravingDisclaimer");
    if (kcHasEngraving) {
        if (!sharedDisclaimer) {
            sharedDisclaimer = document.createElement("p");
            sharedDisclaimer.id = "otmEngravingDisclaimer";
            sharedDisclaimer.className = "otm-engraving__disclaimer";
            grid.insertAdjacentElement("afterend", sharedDisclaimer);
        }
        const anyEngraved = uploadedPhotos.some(p => p.engrave);
        sharedDisclaimer.style.display = anyEngraved ? "block" : "none";
        sharedDisclaimer.textContent = "This preview is a visual guide for placement and sizing. The actual engraved color and finish will vary naturally with the band's material and cannot be reproduced exactly on screen.";
    } else if (sharedDisclaimer) {
        sharedDisclaimer.style.display = "none";
    }

    updateKcTotal();
    refreshUI();
}

function updateKcTotal(){
    const el = document.getElementById("otmVariantsJson");
    const priceEl = document.getElementById("otmProductPrice");
    if (!el || !priceEl) return;
    let variants;
    try { variants = JSON.parse(el.textContent); } catch (e) { return; }

    // Only take over the price display for keychain-style products
    // (products with a Band Color option). Everything else is left to
    // otm-variant-picker's own price-setting path.
    const isKeychain = variants.length > 0 && variants[0].option1 !== undefined
        && document.getElementById("otmColorLegend");
    if (!isKeychain) return;

    let total = 0;

    if (uploadedPhotos.length === 0) {
        // No photos yet: estimate using the pack count and the first
        // color's non-engraved price, so the customer sees a sensible
        // starting number as soon as they set "Number of Packs".
        const baseVariant = variants.find(v => !/engraved/i.test(v.option2 || ""));
        const qty = (typeof selectedQuantity === "number" && selectedQuantity > 0) ? selectedQuantity : 1;
        total = baseVariant ? baseVariant.price * qty : 0;
    } else {
        uploadedPhotos.forEach(photo => {
            if (photo.bandColor === undefined) return;
            const v = variants.find(av =>
                av.option1 === photo.bandColor &&
                (photo.engrave ? /engraved/i.test(av.option2 || "") : !/engraved/i.test(av.option2 || ""))
            );
            if (v) total += v.price * (photo.copies || 1);
        });
    }

    priceEl.textContent = "$" + (total / 100).toFixed(2);
}

grid.addEventListener("click", function(e){

    const id = e.target.dataset.id;
    if(!id) return;

    const photo = uploadedPhotos.find(p => p.id == id);

    if (e.target.classList.contains("otm-plus")) {

    if (FRAME_COUNT > 0) return;

    photo.copies++;

    refreshEverything();

    return;

}

    if (e.target.classList.contains("otm-minus")) {

    if (photo.copies > 1) {

        photo.copies--;

        refreshEverything();

    }

    return;

}

if (e.target.classList.contains("otm-remove")) {

    const photo =
        uploadedPhotos.find(p => p.id == id);

    if (photo) {

        URL.revokeObjectURL(photo.originalPreview);

    }

    uploadedPhotos =
        uploadedPhotos.filter(p => p.id != id);

    if (uploadedPhotos.length === 0) {

        document
            .getElementById("otmReviewPage")
            .classList.remove("active");

        document
            .querySelector(".otm-product")
            .style.display = "block";

        renderPhotos();

        refreshUI();

        return;

    }

    refreshEverything();

    return;

}
});

    function updateCounter() {

    const order =
        getOrderSummary();
    if (FRAME_COUNT > 0) {
        counter.innerHTML = `${order.totalMagnets} / ${order.capacity} photos added`;
    } else if (FIXED_PACK > 0) {
        counter.innerHTML = `${order.totalMagnets} / ${order.capacity} photos added`;
    } else {
        counter.innerHTML = `${order.totalMagnets} / ${order.capacity} Magnets Selected`;
    }
}

    function autoUpgradePack() {

        if (FRAME_COUNT > 0) { refreshUI(); return; }

        if (FIXED_PACK > 0) {
            if (getTotalMagnets() > getCapacity()) {
                alert("Increase the Number of Packs to add more photos.");
            }
            refreshUI();
            return;
        }

        const total = getTotalMagnets();
        if (total <= getCapacity()) {
            refreshUI();
            return;
        }

        // Customer chose multiple packs.
        // Never auto-upgrade.
        if (selectedQuantity > 1) {
            alert(
                "You've reached the maximum number of magnets for the selected pack and quantity.\n\nIncrease the quantity or use Bulk Orders."
            );
            return;
        }

        const available =
            getAvailablePacks();

        const nextPack =
            available.find(
                pack => pack >= total
            );
        if (!nextPack) {
            alert(
                "You've reached our largest available pack.\n\nIncrease the quantity or use Bulk Orders."
            );
            return;
        }
        selectedPack = nextPack;
        highlightPack(nextPack);
        refreshUI();
    }

    function highlightPack(packQty, refresh = true) {

        packs.forEach(pack => {

            const active =
                Number(pack.dataset.pack) === packQty;

            pack.classList.toggle("active", active);

            if (active) {

                selectedPack =
                    Number(pack.dataset.pack);

                selectedVariantId =
                    Number(pack.dataset.variantId);

            }

        });

        if (refresh) {

            refreshUI();

        }

    }

    function openCropper(){
        cropModal.classList.add("active");
        document.body.classList.add("otm-crop-open");
        loadCurrentPhoto();
    }


    function loadCurrentPhoto(){
        if(currentCropIndex < 0) return;

        if(currentCropIndex >= uploadedPhotos.length){
            console.warn("Invalid crop index:", currentCropIndex);
            return;
        }   
        if(cropper){
            cropper.destroy();
        }
        const photo = uploadedPhotos[currentCropIndex];

        // Restore this photo's text settings into the controls
        const magnetTextInput = document.getElementById("magnetText");
        const fontCtrl = document.getElementById("magnetTextFont");
        const sizeCtrl = document.getElementById("magnetTextSize");
        const posCtrl = document.getElementById("magnetTextPos");

        if (magnetTextInput) {
            magnetTextInput.value = photo.text || "";
        }
        if (fontCtrl) {
            fontCtrl.value = photo.textFont || "Poppins";
        }
        if (sizeCtrl) {
            sizeCtrl.value = photo.textSize || 9;
        }
        const colorCtrl = document.getElementById("magnetTextColor");
        if (colorCtrl) {
            colorCtrl.value = photo.textColor || "#ffffff";
        }
        if (posCtrl) {
            [...posCtrl.querySelectorAll("button")].forEach(b => {
                b.classList.toggle("active", b.dataset.pos === (photo.textPos || "bottom"));
            });
        }

        // Restore this photo's adjustment sliders
        const brightCtrl = document.getElementById("adjBrightness");
        const contrastCtrl = document.getElementById("adjContrast");
        const satCtrl = document.getElementById("adjSaturation");
        if (brightCtrl) brightCtrl.value = photo.brightness ?? 100;
        if (contrastCtrl) contrastCtrl.value = photo.contrast ?? 100;
        if (satCtrl) satCtrl.value = photo.saturation ?? 100;

        // cropTitle.textContent =
        //     `Crop Photo ${currentCropIndex+1} of ${uploadedPhotos.length}`;
        if(cropSource === "review"){
            cropTitle.textContent = "Adjust Photo";
        }
        else{
            cropTitle.textContent =
                `Crop Photo ${currentCropIndex+1} of ${uploadedPhotos.length}`;
        }
        cropImage.src = photo.originalPreview;
        cropImage.onload = ()=>{
            document.body.classList.toggle("otm-round-crop", magnetSpec().shape === "circle");
            cropper = new Cropper(cropImage,{
                aspectRatio: magnetSpec().ratio,
                viewMode:1,
                dragMode:"move",
                autoCropArea:0.82,
                responsive:true,
                background:false,
                guides:false,
                center:true,
                movable:true,
                scalable:false,
                zoomable:true,
                rotatable:true,
                ready(){
                    attachTextPreview();
                    updateAdjustPreview();
                },
                crop(){
                    updateTextPreview();
                }
            }); 
        };
    }

    function closeCropper(){
        if(cropper){
            cropper.destroy();
            cropper = null;
        }
        cropModal.classList.remove("active");
        document.body.classList.remove("otm-crop-open");
    }

    cropClose.addEventListener("click",()=>{
        closeCropper();
        if(cropSource === "review"){
            openReviewPage();
        }
    });

    // Zoom controls
    const zoomInBtn = document.getElementById("zoomIn");
    const zoomOutBtn = document.getElementById("zoomOut");
    const rotateBtn = document.getElementById("rotatePhoto");

    if (rotateBtn) {
        rotateBtn.addEventListener("click", () => {
            if (cropper) cropper.rotate(90);
        });
    }

    if (zoomInBtn) {
        zoomInBtn.addEventListener("click", () => {
            if (cropper) cropper.zoom(0.1);
        });
    }

    if (zoomOutBtn) {
        zoomOutBtn.addEventListener("click", () => {
            if (cropper) cropper.zoom(-0.1);
        });
    }

    /* ===========================================
       Text on magnet: live preview + controls
    =========================================== */

    let textPreviewEl = null;

    function attachTextPreview() {
        const cropBox = document.querySelector(".cropper-crop-box");
        if (!cropBox) return;
        textPreviewEl = document.createElement("div");
        textPreviewEl.className = "otm-text-preview";
        cropBox.appendChild(textPreviewEl);
        updateTextPreview();
    }

    function updateTextPreview() {
        if (!textPreviewEl || !cropper) return;
        const photo = uploadedPhotos[currentCropIndex];
        if (!photo) return;

        textPreviewEl.textContent = photo.text || "";
        textPreviewEl.style.fontFamily =
            '"' + (photo.textFont || "Poppins") + '", sans-serif';
        textPreviewEl.style.color = photo.textColor || "#ffffff";
        textPreviewEl.style.textShadow =
            isLightColor(photo.textColor || "#ffffff")
                ? "0 1px 6px rgba(0,0,0,.6)"
                : "0 1px 6px rgba(255,255,255,.65)";

        const box = cropper.getCropBoxData();
        const pct = (photo.textSize || 9) / 100;
        textPreviewEl.style.fontSize =
            Math.max(10, Math.round(box.width * pct)) + "px";

        textPreviewEl.classList.remove("pos-top", "pos-middle", "pos-bottom");
        textPreviewEl.classList.add("pos-" + (photo.textPos || "bottom"));
    }

    // Is a hex color light? (decides whether the outline should be dark or light)
    function isLightColor(hex) {
        if (!hex || hex[0] !== "#" || hex.length < 7) return true;
        const r = parseInt(hex.substr(1, 2), 16);
        const g = parseInt(hex.substr(3, 2), 16);
        const b = parseInt(hex.substr(5, 2), 16);
        return (0.299 * r + 0.587 * g + 0.114 * b) > 150;
    }

    const textInputCtrl = document.getElementById("magnetText");
    const textFontCtrl = document.getElementById("magnetTextFont");
    const textSizeCtrl = document.getElementById("magnetTextSize");
    const textPosCtrl = document.getElementById("magnetTextPos");
    const textColorCtrl = document.getElementById("magnetTextColor");

    if (textColorCtrl) {
        textColorCtrl.addEventListener("input", () => {
            const photo = uploadedPhotos[currentCropIndex];
            if (!photo) return;
            photo.textColor = textColorCtrl.value;
            updateTextPreview();
        });
    }

    if (textInputCtrl) {
        textInputCtrl.addEventListener("input", () => {
            const photo = uploadedPhotos[currentCropIndex];
            if (!photo) return;
            photo.text = textInputCtrl.value;
            updateTextPreview();
        });
    }

    if (textFontCtrl) {
        textFontCtrl.addEventListener("change", () => {
            const photo = uploadedPhotos[currentCropIndex];
            if (!photo) return;
            photo.textFont = textFontCtrl.value;
            updateTextPreview();
        });
    }

    if (textSizeCtrl) {
        textSizeCtrl.addEventListener("input", () => {
            const photo = uploadedPhotos[currentCropIndex];
            if (!photo) return;
            photo.textSize = Number(textSizeCtrl.value);
            updateTextPreview();
        });
    }

    if (textPosCtrl) {
        textPosCtrl.addEventListener("click", (e) => {
            const btn = e.target.closest("button[data-pos]");
            if (!btn) return;
            const photo = uploadedPhotos[currentCropIndex];
            if (!photo) return;
            photo.textPos = btn.dataset.pos;
            [...textPosCtrl.querySelectorAll("button")].forEach(b => {
                b.classList.toggle("active", b === btn);
            });
            updateTextPreview();
        });
    }

    /* ===========================================
       Photo adjustments: brightness / contrast /
       saturation, with live preview
    =========================================== */

    const adjBrightness = document.getElementById("adjBrightness");
    const adjContrast = document.getElementById("adjContrast");
    const adjSaturation = document.getElementById("adjSaturation");
    const adjAuto = document.getElementById("adjAuto");
    const adjReset = document.getElementById("adjReset");

    function updateAdjustPreview() {
        const photo = uploadedPhotos[currentCropIndex];
        if (!photo) return;
        const filter =
            "brightness(" + ((photo.brightness ?? 100) / 100) + ") " +
            "contrast(" + ((photo.contrast ?? 100) / 100) + ") " +
            "saturate(" + ((photo.saturation ?? 100) / 100) + ")";
        cropModal
            .querySelectorAll(".cropper-canvas img, .cropper-view-box img")
            .forEach(img => {
                img.style.filter = filter;
            });
    }

    function setAdjustments(b, c, s) {
        const photo = uploadedPhotos[currentCropIndex];
        if (!photo) return;
        photo.brightness = b;
        photo.contrast = c;
        photo.saturation = s;
        if (adjBrightness) adjBrightness.value = b;
        if (adjContrast) adjContrast.value = c;
        if (adjSaturation) adjSaturation.value = s;
        updateAdjustPreview();
    }

    if (adjBrightness) {
        adjBrightness.addEventListener("input", () => {
            const photo = uploadedPhotos[currentCropIndex];
            if (!photo) return;
            photo.brightness = Number(adjBrightness.value);
            updateAdjustPreview();
        });
    }

    if (adjContrast) {
        adjContrast.addEventListener("input", () => {
            const photo = uploadedPhotos[currentCropIndex];
            if (!photo) return;
            photo.contrast = Number(adjContrast.value);
            updateAdjustPreview();
        });
    }

    if (adjSaturation) {
        adjSaturation.addEventListener("input", () => {
            const photo = uploadedPhotos[currentCropIndex];
            if (!photo) return;
            photo.saturation = Number(adjSaturation.value);
            updateAdjustPreview();
        });
    }

    if (adjAuto) {
        adjAuto.addEventListener("click", () => {
            // Gentle pop: slightly brighter, punchier, more vivid
            setAdjustments(105, 108, 114);
        });
    }

    if (adjReset) {
        adjReset.addEventListener("click", () => {
            setAdjustments(100, 100, 100);
        });
    }

    // Bake the adjustments into the final canvas.
    // Uses fast canvas filters when the browser supports them,
    // otherwise falls back to per-pixel math (Safari).
    function applyAdjustments(canvas, photo) {
        const b = (photo.brightness ?? 100) / 100;
        const c = (photo.contrast ?? 100) / 100;
        const s = (photo.saturation ?? 100) / 100;

        if (b === 1 && c === 1 && s === 1) return canvas;

        const out = document.createElement("canvas");
        out.width = canvas.width;
        out.height = canvas.height;
        const ctx = out.getContext("2d");

        if ("filter" in ctx) {
            ctx.filter =
                "brightness(" + b + ") contrast(" + c + ") saturate(" + s + ")";
            ctx.drawImage(canvas, 0, 0);
            return out;
        }

        // Pixel fallback
        ctx.drawImage(canvas, 0, 0);
        const imageData = ctx.getImageData(0, 0, out.width, out.height);
        const d = imageData.data;
        for (let i = 0; i < d.length; i += 4) {
            let r = d[i], g = d[i + 1], bl = d[i + 2];
            // brightness
            r *= b; g *= b; bl *= b;
            // contrast
            r = (r - 128) * c + 128;
            g = (g - 128) * c + 128;
            bl = (bl - 128) * c + 128;
            // saturation
            const gray = 0.2126 * r + 0.7152 * g + 0.0722 * bl;
            r = gray + (r - gray) * s;
            g = gray + (g - gray) * s;
            bl = gray + (bl - gray) * s;
            d[i] = Math.max(0, Math.min(255, r));
            d[i + 1] = Math.max(0, Math.min(255, g));
            d[i + 2] = Math.max(0, Math.min(255, bl));
        }
        ctx.putImageData(imageData, 0, 0);
        return out;
    }

    cropBack.addEventListener("click", async () => {
        if(currentCropIndex===0){
            // First photo: save progress and go back to the upload screen
            await saveCrop();
            closeCropper();
            if(cropSource === "review"){
                cropSource = "product";
                openReviewPage();
            }
            return;
        }
        await saveCrop();
        currentCropIndex--;
        loadCurrentPhoto();

    });

    cropNext.addEventListener("click", async () => {
        await saveCrop();
        showCropSaved();
        // if(currentCropIndex === uploadedPhotos.length - 1){
        //     setTimeout(()=>{
        //         closeCropper();
        //         openReviewPage();
        //     },600);
        //     return;
        // }
        if(cropSource === "review"){
            await saveCrop();
            closeCropper();
            cropSource = "product";
            openReviewPage();
            return;
        }
        setTimeout(()=>{
            if(currentCropIndex >= uploadedPhotos.length - 1){
                closeCropper();
                cropSource = "product";
                openReviewPage();
                return;
            }
            currentCropIndex++;
            loadCurrentPhoto();
        },600);
    });

    async function saveCrop() {

        const photo = uploadedPhotos[currentCropIndex];
        if (!photo) return;
        if (!cropper) return;
        photo.crop = cropper.getData(true);

        // Save the optional text for this photo
        const magnetTextInput = document.getElementById("magnetText");
        if (magnetTextInput) {
            photo.text = magnetTextInput.value.trim();
        }

        let canvas = cropper.getCroppedCanvas({
            width: magnetSpec().outW,
            height: magnetSpec().outH,
            imageSmoothingQuality: "high"
        });

        // Bake in brightness / contrast / saturation
        canvas = applyAdjustments(canvas, photo);

        // Draw the text onto the image so it prints on the magnet
        if (photo.text) {
            const ctx = canvas.getContext("2d");
            const family = photo.textFont || "Poppins";
            const pct = (photo.textSize || 9) / 100;
            const fontSize = Math.round(canvas.width * pct);
            const fontSpec = '700 ' + fontSize + 'px "' + family + '", sans-serif';

            // Make sure the chosen font is loaded before drawing
            try {
                await document.fonts.load(fontSpec, photo.text);
            } catch (e) {
                console.warn("Font load failed, using fallback:", e);
            }

            ctx.font = fontSpec;
            ctx.textAlign = "center";
            ctx.lineJoin = "round";
            ctx.lineWidth = Math.max(3, Math.round(fontSize / 7));
            const chosen = photo.textColor || "#ffffff";
            ctx.strokeStyle = isLightColor(chosen)
                ? "rgba(0,0,0,.55)"
                : "rgba(255,255,255,.65)";
            ctx.fillStyle = chosen;

            const x = canvas.width / 2;
            // Round magnets: circle mask claws the corners, keep text further in
            const marginPct = magnetSpec().shape === "circle" ? 0.13 : 0.07;
            const margin = Math.round(canvas.height * marginPct);
            let y;

            if (photo.textPos === "top") {
                ctx.textBaseline = "top";
                y = margin;
            } else if (photo.textPos === "middle") {
                ctx.textBaseline = "middle";
                y = canvas.height / 2;
            } else {
                ctx.textBaseline = "bottom";
                y = canvas.height - margin;
            }

            ctx.strokeText(photo.text, x, y);
            ctx.fillText(photo.text, x, y);
        }

        // Keep Base64 preview (used by UI)

        photo.croppedPreview = canvas.toDataURL("image/jpeg", 0.95);
        // NEW: Save Blob for S3 upload
        photo.croppedBlob = await new Promise(resolve => {
            canvas.toBlob(resolve, "image/jpeg", 0.95);
        });
    }
//  Image 
    // const mainImage =
    //     document.getElementById("mainProductImage");

    // const thumbnails =
    //     document.querySelectorAll(".otm-thumb");

    // if(mainImage && thumbnails.length){

    //     thumbnails[0].classList.add("active");

    //     thumbnails.forEach(thumb=>{

    //         thumb.addEventListener("click",()=>{

    //             thumbnails.forEach(t=>
    //                 t.classList.remove("active")
    //             );

    //             thumb.classList.add("active");

    //             mainImage.style.opacity=0;

    //             setTimeout(()=>{

    //                 mainImage.src =
    //                     thumb.dataset.large;

    //                 mainImage.style.opacity=1;

    //             },150);

    //         });

    //     });

    // }
    const mainImage = document.getElementById("mainProductImage");
const thumbnails = document.querySelectorAll(".otm-thumbnail");

thumbnails.forEach((thumb) => {

    thumb.addEventListener("click", () => {

        thumbnails.forEach(t => t.classList.remove("active"));
        thumb.classList.add("active");

        const newImage = thumb.dataset.large;

        mainImage.style.opacity = 0;

        setTimeout(() => {

            // Update BOTH src and srcset
            mainImage.src = newImage;
            mainImage.srcset = newImage;

            mainImage.style.opacity = 1;

        }, 150);

    });

});

    /* ===========================================
    Start QUNATITY
    =========================================== */
    qtyMinus.addEventListener("click", () => {

        if (selectedQuantity > 1) {
            selectedQuantity--;
            qtyValue.textContent =
                selectedQuantity;
            refreshUI();
            renderReviewPage();
        }
    });

    qtyPlus.addEventListener("click", () => {

        selectedQuantity++;
        qtyValue.textContent =
            selectedQuantity;
        refreshUI();
        renderReviewPage();
    });
    /* ===========================================
    END QUNATITY
    =========================================== */


    /* ===========================================
    Start REVIEW PAGE
    =========================================== */
    function openReviewPage(){

        document.querySelector(".otm-product").style.display = "none";
        document
            .getElementById("otmReviewPage")
            .classList.add("active");
        renderReviewPage();
        window.scrollTo({
            top:0,
            behavior:"smooth"
        });
    }

    // Return from review page to the product / upload screen
    const backToEditBtn = document.getElementById("backToEdit");

    if (backToEditBtn) {
        backToEditBtn.addEventListener("click", () => {
            document
                .getElementById("otmReviewPage")
                .classList.remove("active");
            document.querySelector(".otm-product").style.display = "";
            refreshUI();
            window.scrollTo({ top: 0, behavior: "smooth" });
        });
    }

    function renderReviewPage(){
        const cards =
            document.getElementById("reviewCards");
        cards.innerHTML = "";
        uploadedPhotos.forEach((photo,index)=>{
            cards.innerHTML += `
            <div class="otm-review-card">
                <div class="otm-review-image-wrap">
                    <div class="otm-copy-badge">
                        ${photo.copies}×
                    </div>
                    <img
                        src="${photo.croppedPreview}"
                        class="otm-review-image"
                        alt="Magnet Preview">
                </div>
                <div class="otm-review-content">
                    <div class="otm-review-qty">
                        <button
                            class="qty-minus"
                            data-index="${index}">
                            −
                        </button>
                        <span class="qty-text">
                            ${photo.copies}
                            Magnet${photo.copies>1?"s":""}
                        </span>
                        <button
                            class="qty-plus"
                            data-index="${index}">
                            +
                        </button>
                    </div>
                    <button
                        class="edit-crop"
                        data-index="${index}">
                        ✏ Edit Crop
                    </button>
                    <button
                        class="remove-photo"
                        data-index="${index}">
                        🗑 Remove Photo
                    </button>
                </div>
            </div>
            `;
        });

        // document.getElementById("reviewPackName").textContent =
        //     `${selectedPack} Magnet Pack × ${selectedQuantity}`;

        // const totalMagnets =
        //     uploadedPhotos.reduce(
        //         (sum,p)=>sum+p.copies,
        //         0
        //     );

        // document.getElementById("reviewMagnetCount")
        //     .textContent =
        //     `${totalMagnets} / ${getCapacity()}`;

        // document.getElementById("reviewTotalPrice").textContent =
        //     price.textContent;
        updateReviewSummary();
        attachReviewEvents();
        
    }

    function refreshEverything() {

        if (syncPackFromCopies() === false) {
            return;
        }

        renderPhotos();

        renderReviewPage();

        refreshUI();

    }

    function attachReviewEvents() {

        document.querySelectorAll(".qty-plus").forEach(btn => {

            btn.onclick = () => {

                const photo = uploadedPhotos[Number(btn.dataset.index)];

                photo.copies++;

                if (syncPackFromCopies() === false) {

                    photo.copies--;

                    return;

                }

                refreshEverything();

            };

        });

        document.querySelectorAll(".qty-minus").forEach(btn => {

            btn.onclick = () => {

                const photo = uploadedPhotos[Number(btn.dataset.index)];

                if (photo.copies <= 1) return;

                photo.copies--;

                refreshEverything();

            };

        });

        document.querySelectorAll(".edit-crop").forEach(btn => {

            btn.onclick = () => {

                cropSource = "review";

                currentCropIndex = Number(btn.dataset.index);

                openCropper();

            };

        });

        document.querySelectorAll(".remove-photo").forEach(btn => {

            btn.onclick = () => {

                const index = Number(btn.dataset.index);

                const photo = uploadedPhotos[index];

                if (!photo) return;

                if (!confirm("Remove this photo from your order?")) {

                    return;

                }

                URL.revokeObjectURL(photo.originalPreview);

                uploadedPhotos.splice(index, 1);

                if (uploadedPhotos.length === 0) {

                    document
                        .getElementById("otmReviewPage")
                        .classList.remove("active");

                    document
                        .querySelector(".otm-product")
                        .style.display = "block";

                    refreshUI();

                    renderPhotos();

                    return;

                }

                refreshEverything();

            };

        });

    }

    // function syncPackFromCopies() {

    //     if (getTotalMagnets() > getCapacity()) {

    //         autoUpgradePack();

    //     }

    // }

    function syncPackFromCopies() {

        const totalMagnets = getTotalMagnets();

        // Customer selected multiple packs.
        // Never reduce or change their quantity automatically.
        if (selectedQuantity > 1) {

            if (FRAME_COUNT > 0) {
                return totalMagnets <= FRAME_COUNT;
            }

            if (FIXED_PACK > 0) {
                if (totalMagnets > getCapacity()) {
                    alert("Increase the Number of Packs to add more photos.");
                    return false;
                }
                return true;
            }

            if (totalMagnets <= getCapacity()) {
                return true;
            }

            // Need a larger pack while keeping the same quantity
            const requiredPack = Math.ceil(totalMagnets / selectedQuantity);

            const availablePacks = getAvailablePacks();

            const nextPack = availablePacks.find(
                pack => pack >= requiredPack
            );

            if (!nextPack) {

                alert(
                    "You've reached the maximum magnets for your selected quantity.\n\nIncrease the number of packs or visit our Bulk Orders page."
                );

                return false;

            }

            highlightPack(nextPack);

            return true;

        }

        // Quantity = 1
        // Always use the smallest pack that fits.
        const availablePacks = getAvailablePacks();

        const requiredPack = availablePacks.find(
            pack => totalMagnets <= pack
        );

        if (!requiredPack) {

            alert(
                "You've reached our largest available pack.\n\nIncrease the quantity or visit our Bulk Orders page."
            );

            return false;

        }

        if (requiredPack !== selectedPack) {

            highlightPack(requiredPack, false);

        }

        return true;

    }

    // function syncPackFromCopies(){

    //     const totalCopies =
    //         uploadedPhotos.reduce(
    //             (sum,p)=>sum+p.copies,
    //             0
    //         );
    //     if(totalCopies > 12){
    //         alert(
    //             "Orders over 12 magnets must be placed through our Bulk Order page."
    //         );
    //         return false;
    //     }
    //     if(totalCopies<=3){
    //         selectedPack=3;
    //     }
    //     else if(totalCopies<=6){
    //         selectedPack=6;
    //     }
    //     else if(totalCopies<=9){
    //         selectedPack=9;
    //     }
    //     else{
    //         selectedPack=12;
    //     }
    //     highlightPack(selectedPack);
    // }

    // logic for back button
    const reviewBack =
    document.getElementById("reviewBack");

    if(reviewBack){
        reviewBack.addEventListener("click",()=>{
            document
                .getElementById("otmReviewPage")
                .classList.remove("active");

            document
                .querySelector(".otm-product")
                .style.display="block";

            window.scrollTo({
                top:0,
                behavior:"smooth"
            });
        });

    }

    // logic for checkout
    const checkoutButton =
    document.getElementById("checkoutButton");

    if(checkoutButton){
        checkoutButton.addEventListener("click", async () => {

            try {
                checkoutButton.disabled = true;
                showUploadOverlay();
                setUploadProgress(
                    5,
                    0,
                    "Reserving Upload Space"
                );
                const result = await requestUploadUrls();
                setUploadProgress(
                    25,
                    1,
                    "Uploading Photos"
                );
                await uploadAllImages(result);
                setUploadProgress(
                    85,
                    2,
                    "Saving Order Details"
                );
                await uploadManifest(result);
                setUploadProgress(
                    100,
                    3,
                    "Redirecting to Secure Checkout"
                );
                await new Promise(resolve => setTimeout(resolve, 500));
                hideUploadOverlay();
                
                //checkout
                setUploadProgress(
                    100,
                    3,
                    "Creating Secure Checkout"
                );
                await createShopifyCart(result);
                await new Promise(resolve =>
                    setTimeout(resolve, 500)
                );
                window.location.href = "/cart";                
            }
            catch (err) {
                hideUploadOverlay();
                checkoutButton.disabled = false;
                console.error(err);
                alert(err.message);
            }
        });
    }
    /* 
    ===========================================
    End REVIEW PAGE
    =========================================== */

   continueBtn.addEventListener("click", () => {

    const total = getTotalMagnets();

    if (total !== getCapacity()) {

        alert(
            `Please select exactly ${getCapacity()} magnets.`
        );

        return;

    }

    cropSource = "product";
    currentCropIndex = 0;
    openCropper();

});




});